var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('page-form',{staticClass:"subscribe-form",attrs:{"action":"feedback/send","layout":"text-aside","use-container":false,"form-config":_vm.formConfig,"submit-label":_vm.submitLabel,"success-title":"Благодарим за подписку","success-text":"Ваша заявка принята и будет рассмотрена в течение 8 рабочих часов"}})}
var staticRenderFns = []

export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./src/modules/shared/ui/public/forms/SubscribeForm.vue?vue&type=template&id=e9f50ce8&
// module id = 1759
// module chunks = 0